export enum Language {
    "pt-pt" = 1,
    "en-us" = 2,
    "pt-br" = 3,
}